import React, {
  createContext,
  SetStateAction,
  ReactNode,
  useContext,
  Dispatch,
} from 'react'

type SettingsHeaderContextValue = {
  setHeaderButtons: Dispatch<SetStateAction<ReactNode | null>>
  setHeaderTitle: Dispatch<SetStateAction<ReactNode | null>>
  setShowSidebar: Dispatch<SetStateAction<boolean>>
}

const SettingsHeaderContext = createContext<SettingsHeaderContextValue | null>(
  null,
)

export function SettingsHeaderProvider({
  value,
  children,
}: {
  value: SettingsHeaderContextValue
  children: React.ReactNode
}): React.ReactElement {
  return (
    <SettingsHeaderContext.Provider value={value}>
      {children}
    </SettingsHeaderContext.Provider>
  )
}

export function useSettingsHeader(): SettingsHeaderContextValue {
  const ctx = useContext(SettingsHeaderContext)
  if (!ctx) {
    throw new Error(
      'useSettingsHeader must be used within SettingsHeaderProvider',
    )
  }
  return ctx
}
